/**
 * Restricted logins (User.accountKind). A pharmacy login works only on its own
 * page (/pharmacy); the API refuses it everywhere else
 * (evv-backend middlewares/restrictedAccountGuard.js), so the app sends it
 * there and skips the staff shell's requests.
 */

export const PHARMACY_HOME = '/pharmacy';

export const isPharmacyAccount = (user) => user?.accountKind === 'pharmacy';

/** Any restricted login: the staff shell and its background requests are not for it. */
export const isRestrictedAccount = (user) => typeof user?.accountKind === 'string' && user.accountKind.length > 0;

/** Where a restricted login lands after sign-in, or null for a normal account. */
export const restrictedHome = (user) => (isRestrictedAccount(user) ? PHARMACY_HOME : null);
